import { render } from "./grid-buttons.vue?vue&type=template&id=78d71cd0&ts=true"
import script from "./grid-buttons.vue?vue&type=script&lang=ts"
export * from "./grid-buttons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/composants/grid-buttons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78d71cd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78d71cd0', __exports__)) {
    api.reload('78d71cd0', __exports__)
  }
  
  module.hot.accept("./grid-buttons.vue?vue&type=template&id=78d71cd0&ts=true", () => {
    api.rerender('78d71cd0', render)
  })

}


export default __exports__